<template>
  <div v-if="user && user.permision === 'isDev'" class="main">
    <header class="app-header">
      <h1 class="app-title">Test Raise</h1>
      <div style="display: flex; gap: 5px">
        <div class="form-group">
          <label>
            DB:
            <input
              v-model="isJsonFromDB"
              type="radio"
              name="dataSource"
              :value="true"
              class="form-input form-checkbox"
            />
          </label>
          <label>
            API:
            <input
              v-model="isJsonFromDB"
              type="radio"
              name="dataSource"
              :value="false"
              class="form-input form-checkbox"
            />
          </label>
        </div>
        <div class="form-group">
          <label>
            Match id:
            <input
              v-model="matchId"
              type="number"
              step="1"
              class="form-input"
              placeholder="Number"
            />
          </label>
          <button class="mini-btn" @click="getOddsById">🔍</button>
        </div>

        <div class="form-group">
          <label style="margin-right: 10px">
            Part:
            <select v-model="selectedPart" class="form-input">
              <option v-for="p in part" :key="p" :value="p">{{ p }}</option>
            </select></label
          >
        </div>
        <div class="form-group">
          <label style="margin-right: 10px">
            Type:
            <select v-model="selectedType" class="form-input">
              <option
                v-for="p in selectedSignal == 'ticker' ? ['total'] : type"
                :key="p"
                :value="p"
              >
                {{ p }}
              </option>
            </select></label
          >
        </div>
        <div class="form-group">
          <label>
            Step:
            <input
              v-model="step"
              type="number"
              step="1"
              class="form-input"
              placeholder="Number"
            />
          </label>
        </div>
        <div class="form-group">
          <label style="margin-right: 10px">
            Signal:
            <select v-model="selectedSignal" class="form-input">
              <option v-for="p in typeSignal" :key="p" :value="p">
                {{ p }}
              </option>
            </select></label
          >
        </div>
        <button class="start-btn" @click="searchSignal">Start</button>
      </div>
    </header>

    <main class="app-main-content">
      <div class="coluns">
        <div class="column">
          <div style="display: flex">
            <button
              class="mini-btn"
              :disabled="!Boolean(matchOdds)"
              @click="setOdds"
            >
              SET
            </button>
            <button class="mini-btn" @click="cleanOdds">CLEAN</button>
          </div>
          <textarea v-model="jsonData" name="json" />
        </div>
        <div class="column">
          <table class="data-table">
            <thead>
              <tr>
                <th
                  v-for="key in selectedType == 'total'
                    ? ['over', 'total', 'under', 'score', 'min', 'time']
                    : ['home', 'hdp', 'away', 'score', 'min', 'time']"
                  :key="key"
                  :style="key == 'time' ? { width: '100%' } : { width: '50px' }"
                >
                  {{ key }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in mapedOdds"
                :id="item.start ? item.timestamp : null"
                :key="index"
                :style="getDynamicRowStyle(item)"
              >
                <template v-for="(value, key) in item">
                  <td
                    v-if="key !== 'start' && key !== 'end' && key !== 'isLast'"
                    :key="key"
                    :style="key == 'timestamp' ? {} : { width: '50px' }"
                  >
                    {{
                      key == "timestamp"
                        ? formatTimestampWithMoment(value)
                        : value
                    }}
                  </td></template
                >
              </tr>
            </tbody>
          </table>
        </div>
        <div class="column">
          <div class="signals">
            <div v-for="(signal, key) in signals" :key="key">
              <table
                class="signal-table"
                @click="
                  scrollToId(
                    searchSignal == 'raise'
                      ? signal.live.timestamp
                      : signal.timestamp,
                  )
                "
              >
                <thead>
                  <tr>
                    <th
                      v-for="key in titleSignal"
                      :key="key"
                      :style="
                        key == 'time' ? { width: '100%' } : { width: '50px' }
                      "
                    >
                      {{ key }}
                    </th>
                  </tr>
                </thead>
                <tbody v-if="selectedSignal == 'raise'">
                  <tr
                    v-for="(item, index) in [signal.live, signal.first]"
                    :key="index"
                  >
                    <template v-for="(value, key) in item">
                      <td
                        v-if="key !== 'isLast'"
                        :key="key"
                        :style="key == 'timestamp' ? {} : { width: '50px' }"
                      >
                        {{
                          key == "timestamp"
                            ? formatTimestampWithMoment(value)
                            : value
                        }}
                      </td>
                    </template>
                  </tr>
                </tbody>
                <tbody v-else-if="selectedSignal == 'crash'">
                  <tr>
                    <template v-for="(value, key) in signal" :key="key">
                      <td
                        v-if="
                          [
                            'market',
                            'odds',
                            'total',
                            'score',
                            'time',
                            'timestamp',
                          ].includes(key)
                        "
                        :key="key"
                        :style="key == 'timestamp' ? {} : { width: '50px' }"
                      >
                        {{
                          key == "timestamp"
                            ? formatTimestampWithMoment(value)
                            : value
                        }}
                      </td>
                    </template>
                  </tr>
                </tbody>
                <tbody v-else-if="selectedSignal == 'ticker'">
                  <tr>
                    <template v-for="(value, key) in signal" :key="key">
                      <td
                        v-if="
                          [
                            'odds',
                            'type',
                            'total',
                            'score',
                            'time',
                            'timestamp',
                          ].includes(key)
                        "
                        :key="key"
                        :style="key == 'timestamp' ? {} : { width: '50px' }"
                      >
                        {{
                          key == "timestamp"
                            ? formatTimestampWithMoment(value)
                            : value
                        }}
                      </td>
                    </template>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="column" style="width: 250px">
          <div v-if="selectedSignal == 'ticker'">
            <label class="form-label">
              Step max
              <input
                v-model="formData.step.max"
                type="number"
                class="form-input"
                step="0.05"
                placeholder="Наприклад, 0.05"
              />
            </label>
            <label class="form-label">
              Smooth Signals
              <input
                v-model="formData.smoothSignals"
                type="checkbox"
                class="form-input"
              />
            </label>
            <div class="form-group">
              <label style="margin-right: 10px">
                Ticker Type:
                <select v-model="selectedTickerType" class="form-input">
                  <option v-for="p in tickerType" :key="p" :value="p">
                    {{ p }}
                  </option>
                </select></label
              >
            </div>

            <label
              v-for="(item, key) in formData.filter[selectedTickerType]"
              :key="key"
              class="form-label"
            >
              {{ key }}
              <input
                v-if="typeof item == 'string' || typeof item == 'number'"
                v-model="formData.filter[selectedTickerType][key]"
                type="text"
                class="form-input"
                placeholder="Наприклад, 0.25"
              />
              <input
                v-else-if="typeof item == 'boolean'"
                v-model="formData.filter[selectedTickerType][key]"
                type="checkbox"
                class="form-input"
              />
              <template v-else-if="typeof item == 'object'">
                <input
                  v-model="
                    formData.filter[selectedTickerType][key][selectedPart]
                  "
                  type="text"
                  class="form-input"
                  placeholder="Наприклад, 0.25"
                />
              </template>
            </label>
          </div>
          <div v-else-if="selectedSignal == 'raise'">
            <div
              v-for="(_, index) in formData[`${selectedSignal}Bot`][
                selectedPart
              ][selectedType]"
              class="bottom-line"
              :key="index"
            >
              <label
                v-for="(item, key) in formData[`${selectedSignal}Bot`][
                  selectedPart
                ][selectedType][index]"
                :key="key"
                class="form-label"
              >
                {{ key }}
                <input
                  v-if="typeof item == 'string' || typeof item == 'number'"
                  v-model="
                    formData[`${selectedSignal}Bot`][selectedPart][
                      selectedType
                    ][index][key]
                  "
                  type="text"
                  class="form-input"
                  placeholder="Наприклад, 0.25"
                />
                <input
                  v-else-if="typeof item == 'boolean'"
                  v-model="
                    formData[`${selectedSignal}Bot`][selectedPart][
                      selectedType
                    ][index][key]
                  "
                  type="checkbox"
                  class="form-input"
                />
                <template v-else-if="typeof item == 'object'">
                  <input
                    v-for="(value, key2) in item"
                    :key="key2"
                    v-model="
                      formData[`${selectedSignal}Bot`][selectedPart][
                        selectedType
                      ][index][key][key2]
                    "
                    type="text"
                    class="form-input"
                    placeholder="Наприклад, 0.25"
                  />
                </template>
              </label>
            </div>
          </div>
          <div v-else>
            <label
              v-for="(item, key) in formData[`${selectedSignal}Bot`][
                selectedPart
              ][selectedType]"
              :key="key"
              class="form-label"
            >
              {{ key }}
              <input
                v-if="typeof item == 'string' || typeof item == 'number'"
                v-model="
                  formData[`${selectedSignal}Bot`][selectedPart][selectedType][
                    key
                  ]
                "
                type="text"
                class="form-input"
                placeholder="Наприклад, 0.25"
              />
              <input
                v-else-if="typeof item == 'boolean'"
                v-model="
                  formData[`${selectedSignal}Bot`][selectedPart][selectedType][
                    key
                  ]
                "
                type="checkbox"
                class="form-input"
              />
              <template v-else-if="typeof item == 'object'">
                <input
                  v-for="(value, key2) in item"
                  :key="key2"
                  v-model="
                    formData[`${selectedSignal}Bot`][selectedPart][
                      selectedType
                    ][key][key2]
                  "
                  type="text"
                  class="form-input"
                  placeholder="Наприклад, 0.25"
                />
              </template>
            </label>
          </div>
          <button
            class="start-btn"
            style="width: 100%; margin-top: 15px"
            @click="searchSignal"
          >
            Start
          </button>
        </div>
      </div>
    </main>
    <div v-if="isLoading" class="loading-overlay">
      <div class="loading-spinner"></div>
    </div>
  </div>
  <Page404 v-else />
</template>

<script setup>
import moment from "moment";
import { computed, ref, onMounted, onUnmounted, watch } from "vue";
import { HTTP } from "@/api";
import { useStore } from "vuex";
import Page404 from "./Page404.vue";
import { useRoute, useRouter } from "vue-router";

const part = ["FT", "HT"];
const type = ["hdp", "total"];
const typeSignal = ["crash", "raise", "ticker"];
const tickerType = ["sharp", "whale", "lowTrended", "highTrended"];
const initialSettings = {
  crashBot: {
    HT: {
      hdp: {
        maxValue: 1.8,
        reverseMarket: true,
        skipMarkets: [0],
      },
      total: {
        maxValue: 1.8,
        skipMarkets: [0],
      },
    },
    FT: {
      hdp: {
        maxValue: 1.8,
        reverseMarket: false,
        skipMarkets: [0],
      },
      total: {
        maxValue: 1.8,
        skipMarkets: [0],
      },
    },
    companies: [8],
    smoothSignals: false,
    showLiveOdd: true,
  },
  raiseBot: {
    HT: {
      hdp: [
        {
          diff: "0.25",
          stableBefore: "1",
          stableAfter: "1",
          skipMarkets: [0],
          hdpBefore: "3",
          hdpAfter: "3",
        },
        {
          diff: "0.5",
          stableBefore: "1",
          stableAfter: "1",
          skipMarkets: [0],
          hdpBefore: "3",
          hdpAfter: "3",
        },
      ],
      total: [
        {
          diff: "0.25",
          stableBefore: "1",
          stableAfter: "1",
          overBefore: "3",
          overAfter: "3",
        },
        {
          diff: "0.5",
          stableBefore: "1",
          stableAfter: "1",
          overBefore: "3",
          overAfter: "3",
        },
      ],
    },
    FT: {
      hdp: [
        {
          diff: "0.25",
          stableBefore: "1",
          stableAfter: "1",
          skipMarkets: [0.25],
          hdpBefore: "3",
          hdpAfter: "3",
        },
        {
          diff: "0.5",
          stableBefore: "1",
          stableAfter: "1",
          skipMarkets: [0.25],
          hdpBefore: "3",
          hdpAfter: "3",
        },
      ],
      total: [
        {
          diff: "0.25",
          stableBefore: "1",
          stableAfter: "1",
          overBefore: "3",
          overAfter: "3",
        },
        {
          diff: "0.5",
          stableBefore: "1",
          stableAfter: "1",
          overBefore: "3",
          overAfter: "3",
        },
      ],
    },
    smoothSignals: false,
    company: "8",
  },
  time: {
    HT: 45,
    FT: 120,
  },
  step: {
    max: 0.05,
  },
  smoothSignals: false,
  filter: {
    sharp: {
      value: "0.1",
      signal: true,
      timeAttach: false,
      maxTime: {
        HT: 45,
        FT: 85,
      },
      minOdds: {
        HT: 1.8,
        FT: 1.8,
      },
      minTime: {
        HT: 1,
        FT: 1,
      },
      over: {
        HT: "2.1",
        FT: "2.1",
      },
      autoDrop: false,
      noStep: true,
    },
    whale: {
      value: "0.12",
      signal: true,
      timeAttach: false,
      maxTime: {
        HT: 45,
        FT: 85,
      },
      minOdds: {
        HT: 1.8,
        FT: 1.8,
      },
      minTime: {
        HT: 1,
        FT: 1,
      },
      over: {
        HT: "2.1",
        FT: "2.1",
      },
      autoDrop: false,
      noStep: true,
    },
    lowTrended: {
      value: "0.15",
      signal: true,
      timeAttach: false,
      maxTime: {
        HT: 45,
        FT: 85,
      },
      minOdds: {
        HT: 1.8,
        FT: 1.8,
      },
      minTime: {
        HT: 1,
        FT: 1,
      },
      over: {
        HT: "2.1",
        FT: "2.1",
      },
      autoDrop: false,
      noStep: true,
    },
    highTrended: {
      value: "0.2",
      signal: true,
      timeAttach: false,
      maxTime: {
        HT: 45,
        FT: 85,
      },
      minOdds: {
        HT: 1.8,
        FT: 1.8,
      },
      minTime: {
        HT: 1,
        FT: 1,
      },
      over: {
        HT: "2.1",
        FT: "2.1",
      },
      autoDrop: false,
      noStep: true,
    },
  },
};
const store = useStore();
const route = useRoute();
const router = useRouter();

const jsonData = ref(`[]`);
const selectedPart = ref("FT");
const selectedType = ref("total");
const selectedSignal = ref("raise");
const selectedTickerType = ref("sharp");
const signals = ref([]);
const formData = ref({ ...initialSettings });
const step = ref(10);
const isJsonFromDB = ref(false);
const isLoading = ref(false);
const matchId = ref("");
const matchOdds = ref(null);

const user = computed(() => store.state.user);
// eslint-disable-next-line vue/return-in-computed-property
const titleSignal = computed(() => {
  switch (selectedSignal.value + "-" + selectedType.value) {
    case "raise-total":
      return ["over", "total", "under", "score", "min", "time"];
    case "raise-hdp":
      return ["home", "hdp", "away", "min", "score", "time"];
    case "crash-total":
      return ["market", "odds", "total", "score", "min", "time"];
    case "crash-hdp":
      return ["market", "odds", "total", "score", "min", "time"];
    case "ticker-total":
      return ["odds", "min", "type", "total", "time", "score"];
    default:
      break;
  }
});
// eslint-disable-next-line vue/return-in-computed-property
const mapedOdds = computed(() => {
  let fixJson = null;
  let result = [];
  if (typeof jsonData.value !== "string" || jsonData.value.trim() === "") {
    console.warn(
      "mapedOdds: jsonData.value не є дійсним рядком або порожній. Повернення порожнього масиву.",
    );
    return result;
  }

  try {
    fixJson = JSON.parse(jsonData.value.trim());
  } catch (error) {
    console.error("mapedOdds: Помилка при парсингу JSON:", error);
    console.error("Недійсний JSON-рядок:", jsonData.value);
    return result;
  }

  if (isJsonFromDB.value) {
    result = getFormDB(fixJson);
  }
  if (selectedType.value === "total") {
    result = getTotal(fixJson);
  }
  if (selectedType.value === "hdp") {
    result = getHdp(fixJson);
  }

  switch (selectedSignal.value) {
    case "raise":
      return addRaiseSignal(result);
    case "crash":
      return addCrashSignal(result);
    case "ticker":
      return addTickerSignal(result);
    default:
      break;
  }
});

function addRaiseSignal(result) {
  return result.map((item) => {
    const isSignalStart = signals.value.some(
      (signal) => signal.live.timestamp === item.timestamp,
    );
    if (isSignalStart) return { ...item, start: true };

    const isSignalEnd = signals.value.some(
      (signal) => signal.first.timestamp === item.timestamp,
    );

    return isSignalEnd ? { ...item, end: true } : item;
  });
}
function addCrashSignal(result) {
  console.log(signals.value);
  return result.map((item) => {
    const isSignalStart = signals.value.some(
      (signal) => signal.timestamp === item.timestamp,
    );

    return isSignalStart ? { ...item, start: true } : item;
  });
}
function addTickerSignal(result) {
  return result.map((item) => {
    const isSignalStart = signals.value.some(
      (signal) => signal.timestamp === item.timestamp,
    );

    return isSignalStart ? { ...item, start: true } : item;
  });
}

function formatTimestampWithMoment(timestamp) {
  return moment.unix(timestamp).format("HH:mm:ss");
}
function getFormDB(odds) {
  if (odds && odds.length) {
    return odds.map((item) => ({
      over: strToNumberOrNull(item.over),
      total: strToNumberOrNull(item.total),
      under: strToNumberOrNull(item.under),
      score: item.score,
      time: item.time,
      timestamp: item.timestamp,
    }));
  }
  return [];
}
function getTotal(odds) {
  if (isJsonFromDB.value) return odds;

  if (odds && odds.length) {
    return odds.map((item) => ({
      isLast: false,
      over: strToNumberOrNull(item.over_od),
      total: strToNumberOrNull(item.handicap),
      under: strToNumberOrNull(item.under_od),
      score: item.ss,
      time: item.time_str,
      timestamp: item.add_time,
    }));
  }
  return [];
}

function getHdp(odds) {
  if (isJsonFromDB.value) return odds;

  if (odds && odds.length) {
    return odds.map((item) => ({
      isLast: false,
      over: strToNumberOrNull(item.home_od),
      total: strToNumberOrNull(item.handicap),
      under: strToNumberOrNull(item.away_od),
      score: item.ss,
      time: item.time_str,
      timestamp: item.add_time,
    }));
  }
  return [];
}
function strToNumberOrNull(value) {
  const num = Number(value);

  if (isFinite(num)) {
    return Math.round(num * 100) / 100;
  }

  if (value === "-") return null;

  if (typeof value === "string" && value.includes(",")) {
    const numbers = value
      .split(",")
      .map(Number)
      .filter((n) => isFinite(n));

    if (numbers.length > 0) {
      const avg = numbers.reduce((sum, num) => sum + num, 0) / numbers.length;
      return Math.round(avg * 100) / 100;
    }
  }

  const parsedNum = parseFloat(value);
  return isNaN(parsedNum) ? null : Math.round(parsedNum * 100) / 100;
}

const scrollToId = (id) => {
  const targetElement = document.getElementById(id);
  console.log(id);
  if (targetElement) {
    targetElement.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "nearest",
    });
  }
};

const getDynamicRowStyle = (item) => {
  let style = {};
  if (item.start) {
    style["background-color"] = "#4CAF5077";
  } else if (item.end) {
    style["background-color"] = "#f4433677";
  }
  if (item.isLast) {
    style["border-left"] = "solid 5px #0000ff";
  }
  return style;
};

function setOdds() {
  jsonData.value = JSON.stringify(
    matchOdds.value[selectedPart.value][selectedType.value],
  );
  searchSignal();
}

function cleanOdds() {
  jsonData.value = "[]";
}

async function getOddsById() {
  router.push({
    query: { ...route.query, id: matchId.value },
  });

  isLoading.value = true;
  try {
    const res = await HTTP.get(
      `/v2/test/odds?id=${matchId.value}&isDB=${isJsonFromDB.value}`,
    );

    let data = res.data;
    if (data && data.success) {
      matchOdds.value = {
        FT: {
          hdp: data.odds.FThdp,
          total: data.odds.FT,
        },
        HT: {
          hdp: data.odds.HThdp,
          total: data.odds.HT,
        },
      };
      setOdds();
    } else {
      console.error("Помилка відповіді від сервера:", data.message);
      return;
    }
  } catch (e) {
    console.log(e);
  } finally {
    isLoading.value = false;
  }
}

async function searchSignal() {
  isLoading.value = true;
  signals.value = [];
  const key = `${selectedPart.value}${selectedType.value == "hdp" ? "hdp" : ""}`;
  const settings = formData.value;
  try {
    let odds = {
      FT: [],
      FThdp: [],
      HT: [],
      HThdp: [],
      lastChecks: {
        raise_FT: 0,
        raise_FThdp: 0,
        raise_HT: 0,
        raise_HThdp: 0,
        crash_FT: 0,
        crash_FThdp: 0,
        crash_HT: 0,
        crash_HThdp: 0,
      },
      stopTimestamp: 1742054917,
    };
    const oddsArray = [...mapedOdds.value];
    if (isJsonFromDB.value) {
      let tempArr = [];
      const dataOdds = [];

      for (let i = oddsArray.length - 1; i > 0; i -= 1) {
        if (oddsArray[i].isLast) {
          tempArr.reverse();
          dataOdds.push(tempArr);
          tempArr = [];
        }
        tempArr.push(oddsArray[i - 1]);
      }
      for (let i = 0; i < dataOdds.length; i += 1) {
        odds[key].unshift(...dataOdds[i]);
        console.log(odds[key]);
        const res = await HTTP.post(`/v2/test/${selectedSignal.value}-signal`, {
          odds,
          key,
          settings,
          part: selectedPart.value,
          type: selectedType.value,
        });

        let data = res.data;
        if (data && data.success) {
          const {
            signals: newSignals,
            signal,
            latest,
            tickerSet,
          } = data.result;
          if (newSignals) {
            signals.value.push(...newSignals);
          }
          if (signal) {
            signals.value.push(signal);
          }
          if (latest) {
            odds.lastChecks[latest.key] = latest.value;
          }
          if (tickerSet?.key) {
            odds[tickerSet.key] = tickerSet.value;
          }
        } else {
          console.error("Помилка відповіді від сервера:", data.message);
          return;
        }
      }
    } else {
      for (let i = oddsArray.length; i > 0; i -= step.value) {
        const chunk = oddsArray.slice(Math.max(0, i - step.value), i);
        if (chunk.length === 0) break;
        odds[key].unshift(...chunk);
        const res = await HTTP.post(`/v2/test/${selectedSignal.value}-signal`, {
          odds,
          key,
          settings,
          part: selectedPart.value,
          type: selectedType.value,
        });
        let data = res.data;
        if (data && data.success) {
          const {
            signals: newSignals,
            signal,
            latest,
            tickerSet,
          } = data.result;
          if (newSignals) {
            signals.value.push(...newSignals);
          }
          if (signal) {
            signals.value.push(signal);
          }
          if (latest) {
            odds.lastChecks[latest.key] = latest.value;
          }
          if (tickerSet?.key) {
            odds[tickerSet.key] = tickerSet.value;
          }
        } else {
          console.error("Помилка відповіді від сервера:", data.message);
          return;
        }
      }
    }
  } catch (e) {
    console.log(e);
  } finally {
    isLoading.value = false;
  }
}

watch(selectedPart, (value) => {
  router.push({
    query: { ...route.query, part: value },
  });
  if (matchOdds.value) setOdds();
});

watch(selectedType, (value) => {
  router.push({
    query: { ...route.query, type: value },
  });
  if (matchOdds.value) setOdds();
});

watch(selectedSignal, (value) => {
  router.push({
    query: { ...route.query, signal: value },
  });
  if (matchOdds.value) setOdds();
});

watch(
  formData,
  (newSettings) => {
    localStorage.setItem("testing-settings", JSON.stringify(newSettings));
  },
  { deep: true },
);

onMounted(() => {
  document.documentElement.style.overflow = "hidden";

  if (route.query.signal) {
    selectedSignal.value = route.query.signal;
  }
  if (route.query.type) {
    selectedType.value = route.query.type;
  }
  if (route.query.part) {
    selectedPart.value = route.query.part;
  }

  if (route.query.id) {
    matchId.value = route.query.id;
    getOddsById();
  }

  const savedSettings = localStorage.getItem("testing-settings");
  if (savedSettings) {
    formData.value = JSON.parse(savedSettings);
  }
});
onUnmounted(() => {
  document.documentElement.style.overflow = "";
});
</script>

<style scoped lang="scss">
html {
  overflow: hidden;
}
textarea {
  width: 100%;
  margin: 10px 0;
  background-color: #d4d3d3;
  height: calc(100% - 40px);
  padding: 3px;
  font-family: monospace;
  box-sizing: border-box;
  font-size: 14px;
}
.mini-btn {
  height: 30px;
  padding: 0 10px;
  background-color: #999;
  font-size: 20px;
  border-radius: 10px;
  margin-right: 10px;
}
.signal-table {
  border-collapse: collapse;
  width: 100%;
  margin: 10px 0;

  & th,
  & td {
    border: 1px solid #111111;
    padding: 3px;
    text-align: center;
  }

  & th {
    background-color: #f2f2f2;
    font-weight: bold;
    text-transform: capitalize;
  }
}
.data-table {
  position: relative;
  border-collapse: collapse;
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
  font-family: sans-serif;

  & thead,
  & tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
  }
  & tbody {
    display: block;
    height: calc(100vh - 160px);
    overflow-y: auto;
    overflow-x: hidden;
  }
  & th,
  & td {
    border: 1px solid #111111;
    padding: 3px;
    text-align: center;
  }

  & th {
    background-color: #f2f2f2;
    font-weight: bold;
    text-transform: capitalize;
  }

  & tbody tr:nth-child(even) {
    background-color: #ebe3e3;
  }

  & tbody tr:hover {
    background-color: #d4d3d3;
  }
}
.main {
  position: fixed;
  pointer-events: auto;
  z-index: 100000;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw !important;
  background-color: #1a202c;
  color: #f7fafc;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;

  .coluns {
    position: relative;
    display: flex;
    gap: 10px;
    height: 100%;
    .column {
      width: 100%;
      height: 100%;
      padding: 5px;
      background-color: #f7fafc;
      color: #1a202c;
      .signals {
        overflow-y: scroll;
        height: 100%;
      }
    }
  }
}

.app-header {
  padding: 0.3rem 1.5rem;
  background-color: #2d3748;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
}

.app-title {
  font-size: 1.875rem;
  font-weight: bold;
}

.start-btn {
  padding: 7px 20px;
  background-color: #4299e1;
  color: #fff;
  border-radius: 0.375rem;
  border: none;
  cursor: pointer;
  font-weight: 600;
  transition:
    background-color 0.2s ease-in-out,
    box-shadow 0.2s ease-in-out;
  outline: none;

  &:hover {
    background-color: #3182ce;
  }

  &:focus {
    box-shadow: 0 0 0 2px rgba(66, 153, 225, 0.5);
  }
}

.app-main-content {
  padding: 1rem;
  height: calc(100% - 50px);
}

.form-group {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.form-label {
  display: block;
  font-size: 0.875rem; /* 14px */
  font-weight: 500;
  color: #32383f;
  margin-bottom: 0.25rem;
  margin-right: 10px;
}

.form-input {
  width: 100px;
  padding: 0.15rem;
  border: 1px solid #4a5568;
  border-radius: 0.375rem;
  background-color: #4a5568;
  color: #fff;
  font-size: 1rem;
  outline: none;
  transition:
    border-color 0.2s ease-in-out,
    box-shadow 0.2s ease-in-out;

  &:focus {
    border-color: #4299e1;
    box-shadow: 0 0 0 2px rgba(66, 153, 225, 0.5);
  }
}

.form-checkbox {
  width: 25px;
  height: 20px;
  vertical-align: middle;
}
.loading-overlay {
  position: fixed; /* Фіксуємо ширму до вікна перегляду */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6); /* Напівпрозорий чорний фон */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999; /* Перекриває більшість інших елементів */
  color: white;
  font-size: 1.2em;
}

.loading-spinner {
  border: 6px solid #f3f3f3; /* Light grey */
  border-top: 6px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite; /* Анімація обертання */
  margin-bottom: 15px;
}

.loading-message {
  margin-top: 0;
}

.bottom-line:not(:last-child) {
  border-bottom: solid;
  margin-bottom: 10px;
  padding-bottom: 10px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
